import { WavetrakRequest } from 'types/wavetrak';

const getCloudflareCountryCode = (req: WavetrakRequest | undefined) =>
  !!req && req?.headers?.['cf-ipcountry'] ? req?.headers?.['cf-ipcountry']?.toString() : null;

export default getCloudflareCountryCode;
